module.exports = __webpack_public_path__ + "static/img/pos.6888a32f.png";